import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { nativeService } from '../helpers/nativeService';
import {
  NativeResponseSource,
  NativeResponseType,
} from '../interface/native.interface';

const Logout = () => {
  const auth = useAuth();

  useEffect(() => {
    localStorage.removeItem('impersonateUser');
    nativeService(
      JSON.stringify({
        source: NativeResponseSource.LOGIN_STATUS,
        status: false,
        type: NativeResponseType.OIDC_CLEAR,
      }),
    );
    auth.signoutRedirect();
  }, []);

  return <p>Logging Out</p>;
};

export default Logout;
